import React from 'react';
import { Box, FormPreloader, useWatch } from '@common-fe/common-fe';

import ModuleWrapper from '@/modules/plan/ModuleWrapper';

import { usePermissionsListQuery } from '../../queries';
import {  RoleLevel } from '../../role.types';

import PermissionToggleBlock from './PermissionToggleBlock';

interface Props {
  roleId?:string;
  isLoading?: boolean;
  isDisabled?: boolean;
  isEditMode?: boolean;
}
const PermissionToggleSection: React.FC<Props> = ({isDisabled, roleId, isEditMode, isLoading }) => {
  const level = useWatch({
    name: 'level'
  }) as RoleLevel;
  const { groups } = usePermissionsListQuery({
    roleId,
    isRoleEditAllowed: level !== RoleLevel.Global && level !== RoleLevel.Partner
  });
  
  return (
    <Box>
      {isLoading ? (
        <ModuleWrapper 
          title=""
          anchorId="">
          <Box round="container1Round" background="canvas" pad="l" border={{ size: 'small', color: 'border1' }}>
            <FormPreloader count={16} />
          </Box>
        </ModuleWrapper>
      ) :
        groups.map((group) => (
          <ModuleWrapper
            key={group.id}
            testId={group.id}
            anchorId={group.id}
            title={group.name}
            expandless
          >
            <PermissionToggleBlock isDisabled={isDisabled} isEditMode={isEditMode} id={group.id} options={group.options} />
          </ModuleWrapper>
        ))}
      
         
    </Box>
   
  );
};
export default PermissionToggleSection;
